import React, { useEffect } from "react";
import { Button, Space, Col, Row } from "antd";
import { Controller, useForm } from "react-hook-form";
import styles from "./add-edit-owners.module.css";
import CustomDrawer from "../../../../../common/custom-drawer/custom-drawer";
import CustomTextfield from "../../../../../common/input/custom-textfield/custom-textfield";
import { createInstitutionOwners, updateInstitutionOwners } from "../../../../../services/institution";
import { PhoneOutlined } from "@ant-design/icons";

const AddEditOwners = ({ open, onClose, editOwnerDetails }) => {
  const { control, handleSubmit, reset } = useForm();
  
  useEffect(() => {
    if (editOwnerDetails?.id) {
      reset({
        ownerName: editOwnerDetails?.name,
        ownerEmail: editOwnerDetails?.email,
        ownerPhoneNo: editOwnerDetails?.phone_number,
        ownerWebsite: editOwnerDetails?.website,
        ownerAddress: editOwnerDetails?.address
      });
    }
  }, [editOwnerDetails, reset]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        name: data?.ownerName,
        phone_number: data?.ownerPhoneNo,
        email: data?.ownerEmail,
        website: data?.ownerWebsite,
        address: data?.ownerAddress
      };

      if (editOwnerDetails?.id) {
        await updateInstitutionOwners(editOwnerDetails?.id, payload);
      } else {
        await createInstitutionOwners(payload);
      }
      onClose();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <CustomDrawer
      title={`${editOwnerDetails?.id ? 'Edit' : 'Add'} Institute Owner`}
      open={open}
      onClose={onClose}
      className={styles.drawer}
      width="50vw"
      drawerStyles={{ body: { padding: "24px" } }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.formSectionBox}>
          <Space direction="vertical" style={{ width: "100%" }} size="large">
            <Row gutter={[24, 0]}>
              <Col span={12}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Owner Name<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="ownerName"
                  control={control}
                  rules={{ required: "Owner Name is required" }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextfield
                      id="ownerName"
                      placeholder="Enter institute owner's name"
                      size="large"
                      value={value}
                      onChange={onChange}
                      status={error ? "error" : ""}
                    />
                  )}
                />
              </Col>

              <Col span={12}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Owner Email<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="ownerEmail"
                  control={control}
                  rules={{ required: "Owner Email is required" }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextfield
                      id="ownerEmail"
                      placeholder="Enter institute owner's email"
                      size="large"
                      value={value}
                      onChange={onChange}
                      status={error ? "error" : ""}
                    />
                  )}
                />
              </Col>
            </Row>

            <Row gutter={[24, 0]}>
              <Col span={12}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Owner Phone No.<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="ownerPhoneNo"
                  control={control}
                  rules={{ required: "Owner Phone Number is required" }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextfield
                      id="ownerPhoneNo"
                      placeholder="Enter institute owner's phone number"
                      type="number"
                      size="large"
                      value={value}
                      prefix={
                        <PhoneOutlined style={{ color: "#999999", paddingRight: 4 }} />
                      }
                      onChange={onChange}
                      status={error ? "error" : ""}
                    />
                  )}
                />
              </Col>

              <Col span={12}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Owner Website<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="ownerWebsite"
                  control={control}
                  rules={{ required: "Owner Website is required" }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextfield
                      id="ownerWebsite"
                      placeholder="Enter institute owner's website"
                      size="large"
                      value={value}
                      onChange={onChange}
                      status={error ? "error" : ""}
                    />
                  )}
                />
              </Col>
            </Row>

            <Row gutter={[24, 0]}>
              <Col span={24}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Owner Address<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="ownerAddress"
                  control={control}
                  rules={{ required: "Owner Address is required" }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextfield
                      id="ownerAddress"
                      placeholder="Enter institute owner's address"
                      size="large"
                      value={value}
                      onChange={onChange}
                      status={error ? "error" : ""}
                    />
                  )}
                />
              </Col>
            </Row>
          </Space>
        </div>

        {/* Footer section */}
        <div className={styles.formActions}>
          <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Button onClick={onClose}>Cancel</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "rgba(57, 181, 74, 1)",
                borderColor: "rgba(57, 181, 74, 1)",
              }}
            >
              Save
            </Button>
          </Space>
        </div>
      </form>
    </CustomDrawer>
  );
};

export default AddEditOwners;
